import { ConfigDataType } from './config.interface';

export const DEFAULT_CONFIG: ConfigDataType = {
  env: 'development',
  port: 9015,
  selfHost: "http://analytics23.sepl.local",
  logLevel: 'info',
  maxPayloadSize: '1000mb',
  responseTimeOut: 600,
  staticFilesFolder: 'files',
  database: {
    type: 'mysql',
    host: '165.22.220.143',
    port: 3306,
    username: 'ramakrishna',
    password: 'Schemax@23',
    dbName: 'ftw_ina',
    poolLimit: 200,
    charset: 'utf8_general_ci',
  },
  rateLimiting: {
    ttl: 60,
    limit: 10,
    maxLoginAttempts: 3
  },
  appSepcific: {
    masterDataMigrationUrl: 'http://localhost:3006/migration/triggerMasterDataHourMigrationForSpecificLine',
    trackingDataMigrationUrl: 'http://localhost:3006/migration/triggerTrackingDataHourMigrationForSpecificLine',
  }
};
